import type { GetLightInvoicesResponse } from '@vy/api-definition';
import { GetLightInvoicesResponseSchema } from '@vy/api-definition';
import { vySerialize } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useLightInvoices(
  invoicesIds: string[],
  options?: CustomUseQueryOptions<GetLightInvoicesResponse>,
) {
  return useQuery({
    queryKey: queryKeys.invoice(...invoicesIds),
    queryFn: async () => {
      const api = getPrivateApi();
      const stringifiedInvoicesIds = vySerialize(invoicesIds);
      const getLightInvoicesInvoiceResponse = await api.getLightInvoices({
        invoicesIds: stringifiedInvoicesIds,
      });

      return GetLightInvoicesResponseSchema.parse(getLightInvoicesInvoiceResponse);
    },
    ...options,
  });
}
